import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3b9b6eda"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b9b6eda')) {
      api.createRecord('3b9b6eda', component.options)
    } else {
      api.reload('3b9b6eda', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3b9b6eda", function () {
      api.rerender('3b9b6eda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/home/index.vue"
export default component.exports